export const environment = {
  ENV: 'prod',
  API_URL: 'https://prod.api.myeinvois.my',
  FILES_URL: 'https://assets.myeinvois.my',
  SENTRY_DSN:
    'https://e77c86f54e95f89c095f1cb4a29c51c5@o4507528086355968.ingest.de.sentry.io/4507528463450192',
  CAPTCHA_KEY: '0x4AAAAAABg88zI-pjZYFEdh',
  GTAG_ID: 'G-4XY7TTJNN6',
  clarityID: 't4ghlrkusr',
  RSA_PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr9wYPtgkzRkWMZRYsbYTDGESMNLGx+OsP/Mu5P7CT1+JLKks1h0hT/LJIc23TH5wXGY72ltpooYbQbg6ti/8QR7ICj4ZMVYBdzcTbMuqnC9qJtnBGGxKt/TQT2FH5tLDP3rnR+84qSCq1fVlQAMQrqaiDkbIfQerZJ+wIE07yCCDBGz3zBmGVNBKsPssHGpZtYKIZBe9zmDdNnEYJRE1dErZp/LMJodbcHOmjr1Bo60Ka1AIu+kaVUU9jqCHToVhdC+ndzdAf8zEtFOrWAxSDAH/Yrm+3UQG65fX+mVBvlqP9QgcFgVEo+LCx4/Z7ytNpq8E2a7OdbYrLapIR1GWOwIDAQAB',
};
